import useRealtimeTaskListItems from '@hooks/useRealtimeTaskListItems'
import useRealtimeTaskLists from '@hooks/useRealtimeTaskLists'

import { TaskListItemModel } from '@domain-group/realhub-backend-api-types'

interface RealtimeWrapperProps {
  taskListItem: TaskListItemModel,
}

const RealtimeWrapper = (props: RealtimeWrapperProps) => {
  const { taskListItem } = props

  useRealtimeTaskListItems({ taskListId: taskListItem.task_list_id! })
  useRealtimeTaskLists({ subjectId: taskListItem.id!, subjectType: taskListItem.type! })

  return null
}

export default RealtimeWrapper
